// One width-breakpoint listener. No mobile gallery, viewport-height work or observers.
const desktop = matchMedia('(min-width: 750px)');
const cards = new Set();

class ResultCardMedia extends HTMLElement {
  #mobile;
  #desktopActive = false;

  connectedCallback() {
    cards.add(this);
    this.sync();
  }

  disconnectedCallback() {
    cards.delete(this);
  }

  /** @param {(root: HTMLElement | DocumentFragment) => void} update */
  updateMedia(update) {
    const active = this.querySelector(':scope > [data-card-media-active]');
    const template = this.querySelector(':scope > template[data-desktop-card-media]');
    if (active instanceof HTMLElement) update(active);
    if (template instanceof HTMLTemplateElement) update(template.content);
    if (this.#mobile) update(this.#mobile.content);
  }

  sync() {
    if (desktop.matches === this.#desktopActive) return;
    const active = this.querySelector(':scope > [data-card-media-active]');
    const template = this.querySelector(':scope > template[data-desktop-card-media]');
    if (!active || !(template instanceof HTMLTemplateElement)) return;

    if (desktop.matches) {
      this.#mobile = document.createElement('template');
      this.#mobile.innerHTML = active.innerHTML;
      active.replaceChildren(template.content.cloneNode(true));
    } else if (this.#mobile) {
      // Disconnect and discard desktop instances, including their observers.
      active.replaceChildren(this.#mobile.content.cloneNode(true));
      this.#mobile = undefined;
    }
    this.#desktopActive = desktop.matches;
  }
}

desktop.addEventListener('change', () => cards.forEach((card) => card.sync()));
if (!customElements.get('result-card-media')) {
  customElements.define('result-card-media', ResultCardMedia);
}
